/**
 * CDS-3 — Detect Vite's "stale lazy-chunk" failure mode.
 *
 * When a user has a tab open from before a deploy, Vite's
 * content-hashed chunk filenames have rotated under them. Any
 * `import('…lazy-service…')` from that tab 404s against the CDN. Vite
 * surfaces this as:
 *
 *   `TypeError: Failed to fetch dynamically imported module: …`
 *
 * The global handler at `src/App.tsx:121-158` listens for the
 * window-level `vite:preloadError` event and auto-reloads the tab.
 * Call sites that wrap their own `await import(...)` need a way to
 * spot the same failure shape so they can skip their generic
 * `console.warn` — the global handler is already doing the right
 * thing, and a per-action warn just mislabels a stale-chunk failure
 * as something else (e.g. "updateReportTemplate Firestore write
 * failed: TypeError: Failed to fetch dynamically imported module …",
 * which led triage on the live-prod CDS-3 diagnostic to the wrong
 * bucket).
 *
 * Conservative match: only the canonical Vite error string. Real
 * Firestore / network errors slip past untouched and still surface.
 */
export function isStaleChunkError(err: unknown): boolean {
  if (!err || typeof err !== 'object') return false;
  const msg = (err as { message?: unknown }).message;
  if (typeof msg !== 'string') return false;
  return msg.includes('Failed to fetch dynamically imported module');
}
